import {WithoutSummaryModel} from '../../../../../common/entity/dto/plain/withoutSummary.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';

export class Scanner3dModel extends WithoutSummaryModel {
    model: LovValueSummary;
    defaultScanFormat: LovValueSummary;
    scanMethod: LovValueSummary;
    type: LovValueSummary;
    canHaveAdditionalImage: boolean;

    get is3dScanner(): boolean {
        return this.type?.value === ScannerType.SCANNER_TYPE_3D;
    }

    get is2dScanner(): boolean {
        return this.type?.value === ScannerType.SCANNER_TYPE_2D;
    }
}

export enum ScannerType {
    SCANNER_TYPE_3D = 'SCANNER_TYPE_3D',
    SCANNER_TYPE_2D = 'SCANNER_TYPE_2D'
}
